import { render, staticRenderFns } from "./PopupLayoutOfSelect.vue?vue&type=template&id=281e627a&scoped=true&"
import script from "./PopupLayoutOfSelect.vue?vue&type=script&lang=ts&"
export * from "./PopupLayoutOfSelect.vue?vue&type=script&lang=ts&"
import style0 from "./PopupLayoutOfSelect.vue?vue&type=style&index=0&id=281e627a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281e627a",
  null
  
)

export default component.exports